(() => {
  const interactiveSelector = 'a, button, input, select, textarea, label, [role="button"], [contenteditable="true"]';

  const mergeIdenticalCells = (scope = document) => {
    scope.querySelectorAll('.dwc-series-table').forEach((table) => {
      const groupedCells = new Map();
      const cells = Array.from(table.querySelectorAll('tbody [data-dwc-series-spec-index]'));

      cells.forEach((cell) => {
        cell.hidden = false;
        cell.rowSpan = 1;
        if (cell.dataset.dwcSeriesMergeEnabled !== 'true') return;
        const index = cell.dataset.dwcSeriesSpecIndex;
        if (!groupedCells.has(index)) groupedCells.set(index, []);
        groupedCells.get(index).push(cell);
      });

      groupedCells.forEach((columnCells) => {
        let anchorCell = null;
        let anchorValue = '';

        columnCells.forEach((cell) => {
          const value = cell.dataset.dwcSeriesMergeValue || '';
          if (value && anchorCell && value === anchorValue) {
            anchorCell.rowSpan += 1;
            cell.hidden = true;
          } else {
            anchorCell = cell;
            anchorValue = value;
          }
        });
      });
    });
  };

  let animationFrame;
  const queueRefresh = (scope = document) => {
    cancelAnimationFrame(animationFrame);
    animationFrame = requestAnimationFrame(() => mergeIdenticalCells(scope));
  };

  const observeResults = () => {
    const results = document.getElementById('filter-results');
    if (!results) return;

    new MutationObserver(() => queueRefresh(results)).observe(results, {
      childList: true,
      subtree: true
    });
  };

  const rowAtPointer = (target, pointerY) => {
    const defaultRow = target.closest('[data-dwc-series-variant-url]');
    const sharedCell = target.closest('[data-dwc-series-spec-index][rowspan]');
    if (!sharedCell || sharedCell.rowSpan < 2 || !Number.isFinite(pointerY)) return defaultRow;

    const rows = Array.from(sharedCell.closest('tbody').querySelectorAll('[data-dwc-series-variant-url]'));
    return rows.find((row) => {
      const bounds = row.getBoundingClientRect();
      return pointerY >= bounds.top && pointerY < bounds.bottom;
    }) || defaultRow;
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target || target.closest(interactiveSelector)) return;

    const row = rowAtPointer(target, event.clientY);
    const url = row?.dataset.dwcSeriesVariantUrl;
    if (!url) return;

    if (event.ctrlKey || event.metaKey) {
      window.open(url, '_blank', 'noopener');
      return;
    }

    window.location.assign(url);
  });

  document.addEventListener('keydown', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const row = target.closest('[data-dwc-series-variant-url]');
    if (!row || target !== row) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;

    event.preventDefault();
    const url = row.dataset.dwcSeriesVariantUrl;
    if (url) window.location.assign(url);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      queueRefresh();
      observeResults();
    }, { once: true });
  } else {
    queueRefresh();
    observeResults();
  }

  document.addEventListener('shopify:section:load', (event) => queueRefresh(event.target));
})();

